var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaggedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11560_30907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#DAEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.200195C18.517 0.200195 23.7998 5.48304 23.7998 12C23.7998 18.517 18.517 23.7998 12 23.7998C5.48304 23.7998 0.200195 18.517 0.200195 12C0.200195 5.48304 5.48304 0.200195 12 0.200195Z",
    stroke: "#4BB0FF",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11560_30907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 7.293C12.5059 7.10545 12.2516 7.00006 11.9864 7H8.40039C8.13517 7 7.88082 7.10536 7.69328 7.29289C7.50575 7.48043 7.40039 7.73478 7.40039 8V11.586C7.40045 11.8512 7.50584 12.1055 7.69339 12.293L12.0454 16.645C12.2726 16.8708 12.58 16.9976 12.9004 16.9976C13.2208 16.9976 13.5281 16.8708 13.7554 16.645L17.0454 13.355C17.2712 13.1277 17.398 12.8204 17.398 12.5C17.398 12.1796 17.2712 11.8723 17.0454 11.645L12.6934 7.293Z",
    stroke: "#004F8E",
    strokeWidth: 0.93,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1504 10C10.2885 10 10.4004 9.88807 10.4004 9.75C10.4004 9.61193 10.2885 9.5 10.1504 9.5C10.0123 9.5 9.90039 9.61193 9.90039 9.75C9.90039 9.88807 10.0123 10 10.1504 10Z",
    stroke: "#004F8E",
    strokeWidth: 0.93,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11560_30907",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.622671 0 0 0 0 0.833764 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11560_30907"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11560_30907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6.40039 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaggedIcon);
export default __webpack_public_path__ + "static/media/tagged_icon.f13558358b8e2ec79e1422923f709fa8.svg";
export { ForwardRef as ReactComponent };